// Built-in MatterGen checkpoints (editable-plan spec 0.2, decision 20). The browser names
// a checkpoint only as /models/mattergen/checkpoints/<built-in>, the one model_path shape
// mattergen-service accepts (its BUILTIN_CHECKPOINTS allowlist is pinned to the same router
// table). Part 1a: the path is synthesized from a validated row target by mattergenJobBody
// (src/ai/rows/rowPayloads.js); no plan or row param can supply a model_path.
import { SERVICES } from '../../ai/router/modelRouter';

export const MATTERGEN_CHECKPOINT_ROOT = '/models/mattergen/checkpoints';

/** The 9 built-in checkpoint names: the router's MatterGen variants. */
export const MATTERGEN_BUILTIN_CHECKPOINTS = Object.freeze(Object.keys(SERVICES.mattergen.variants));

const BUILTIN_PATH_RE = /^\/models\/mattergen\/checkpoints\/([A-Za-z0-9_]+)$/;

/** The built-in checkpoint a model_path names, or null. Only an exact
 * /models/mattergen/checkpoints/<built-in> qualifies (surrounding whitespace ignored). */
export function builtinMattergenCheckpoint(modelPath) {
  if (typeof modelPath !== 'string') return null;
  const m = BUILTIN_PATH_RE.exec(modelPath.trim());
  return m && MATTERGEN_BUILTIN_CHECKPOINTS.includes(m[1]) ? m[1] : null;
}
